import { motion } from "framer-motion";
import { MapPin, Phone, Clock } from "lucide-react";

const OFFICES = [
  {
    city: "Los Angeles — Headquarters",
    address: "3530 Wilshire Blvd. Suite 710, Los Angeles, CA 90010",
    phone: "(417) 283-1384",
    hours: "24/7 Legal Hotline Available",
    testid: "contact-address-la-hq",
  },
  {
    city: "Sherman Oaks",
    address: "15303 Ventura Blvd, Suite 900, Sherman Oaks, CA 91403",
    phone: "(417) 283-1384",
    hours: "Mon – Fri: 8:00 AM – 6:00 PM",
  },
  {
    city: "Las Vegas",
    address: "3960 Howard Hughes Pkwy, Suite 500, Las Vegas, NV 89169",
    phone: "(417) 283-1384",
    hours: "Mon – Fri: 8:00 AM – 6:00 PM",
  },
];

export const Locations = () => (
  <section id="offices" className="relative overflow-hidden">
    <img
      src="https://images.unsplash.com/photo-1765249456443-66880d04c697?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxsb3MlMjBhbmdlbGVzJTIwc2t5bGluZSUyMHdpbHNoaXJlJTIwYXJjaGl0ZWN0dXJlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MzgwOTYwNXww&ixlib=rb-4.1.0&q=85"
      alt=""
      aria-hidden="true"
      className="absolute inset-0 h-full w-full object-cover opacity-15"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-950/80 to-navy-950" />
    <div className="relative mx-auto max-w-7xl px-5 py-24 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="mb-12">
        <p className="mb-3 font-mono text-xs tracking-[0.35em] text-gold/80 uppercase">Visit Us</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-50">Office Locations</h2>
      </motion.div>
      <div className="grid gap-6 md:grid-cols-3">
        {OFFICES.map((o, i) => (
          <motion.div
            key={o.city}
            data-testid={o.testid}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.12, duration: 0.6 }}
            className="rounded-2xl border border-gold/15 bg-navy-900/80 p-7 backdrop-blur-sm transition-all duration-300 hover:border-gold hover:shadow-[0_0_30px_rgba(212,175,55,0.12)]"
          >
            <h3 className="font-display text-xl font-semibold text-slate-50">{o.city}</h3>
            <div className="mt-5 space-y-3.5 text-sm text-slate-300">
              <p className="flex items-start gap-2.5"><MapPin size={16} className="mt-0.5 shrink-0 text-gold" /> {o.address}</p>
              <p className="flex items-center gap-2.5"><Phone size={16} className="shrink-0 text-gold" /> <a href="tel:+14172831384" className="hover:text-gold" data-testid={i === 0 ? "contact-phone-main" : undefined}>{o.phone}</a></p>
              <p className="flex items-center gap-2.5"><Clock size={16} className="shrink-0 text-gold" /> {o.hours}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
